/**
 * Initializes sticky planbox behavior.
 *
 * @package Qustodio\Theme
 */

import stickyPlanboxContainer from './sticky-planbox-container';
import featureTable from './feature-table';

const stickyPlanbox = () => {
  let featureTables = [];
  let featureTablesFound = false;

  const initSwiper = () => {
    // eslint-disable-next-line no-unused-vars
    const swiper = new Swiper('.qusd-exp-planbox-sticky__swiper-container', {
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  };

  const init = () => {
    const tableElements = Array.from(document.querySelectorAll('.js-sticky-planboxes'));
    featureTablesFound = tableElements.length > 0;
    if (featureTablesFound) {
      initSwiper();
      stickyPlanboxContainer.init();
      featureTables = tableElements.map((tableElement) => featureTable(tableElement));
      featureTables.forEach((table) => table.init());
    }
  };

  const onResize = () => {
    if (featureTablesFound) {
      featureTables.forEach((table) => table.onResize());
    }
  };

  const onScroll = () => {
    if (featureTablesFound) {
      featureTables.forEach((table) => table.onScroll());
    }
  };

  return {
    init,
    onResize,
    onScroll,
  };
};

export default stickyPlanbox();
